import { render } from "./Addresses.vue?vue&type=template&id=4c805af9&scoped=true"
import script from "./Addresses.vue?vue&type=script&lang=js"
export * from "./Addresses.vue?vue&type=script&lang=js"

import "./Addresses.vue?vue&type=style&index=0&id=4c805af9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c805af9"]])

export default __exports__